var NewsletterForm = function () {

    this.init = function () {

        $('[data-component="newsletter-form"] .scrollbar-inner').scrollbar();

        $('#newsletterFormValidate').validate({
            ignore: '.ignore',
            errorPlacement: function () {
                return true;
            },
            rules: {
                name: {
                    required: true
                },
                email: {
                    required: true,
                    email: true
                },
                ddd: {
                    required: true
                },
                phone: {
                    required: true
                }
            },
            submitHandler: function (form) {

                var submittedForm = $(form);
                var componentID = parseInt(submittedForm.data("id"));

                submittedForm.find("button[type='submit']").attr("disabled", true);

                var newsletterData = {
                    "Name": submittedForm.find("input[name='name']").val(),
                    "Company": submittedForm.find("input[name='company']").val(),
                    "Email": submittedForm.find("input[name='email']").val(),
                    "AreaCode": submittedForm.find("input[name='ddd']").val(),
                    "Telephone": submittedForm.find("input[name='phone']").val()
                };

                $.ajax({
                    type: "POST",
                    url: "/umbraco/surface/Newsletter/Submit",
                    data: JSON.stringify({ "ComponentID": componentID, "NewsletterData": newsletterData }),
                    dataType: "json",
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: function success(response) {

                        $("#newsletterFormValidate").each(function () {
                            this.reset();
                        });

                        if (response) {
                            $("#confirmation-modal").find(".title").text("Cadastro realizado com sucesso!");
                        }
                        else {
                            $("#confirmation-modal").find(".title").text("Falha ao realizar o cadastro!");
                        }
                    },
                    error: function error(e) {
                        $("#confirmation-modal").find(".title").text("Falha ao realizar o cadastro!");
                    },
                    complete: function () {
                        $("#newsletter-form").find(".close-modal").click();

                        setTimeout(function () {
                            $("#confirmation-modal").open();
                        }, 500);

                        submittedForm.find("button[type='submit']").attr("disabled", false);
                    }
                });
            }
        });
    }

    return this.init();
}